import { Fragment, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import toast from 'react-hot-toast';

import { PlusCircleIcon } from '@heroicons/react/outline';
import instance from 'lib/AxiosClient';
import { useTheme } from 'lib/ThemeContext';

function PublicScriptModal(props: { open: any; setOpen: any; callback: any }) {
  const cancelButtonRef = useRef(null);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [script, setScript] = useState('');
  const [thumbnail, setThumbnail] = useState('');

  const { dark } = useTheme();

  const submitScript = () => {
    toast.promise(
      instance.post('/v1/scripts', {
        name,
        description,
        script,
        thumbnail,
      }),
      {
        loading: `Adding script: ${name}...`,
        success: (response) => {
          props.setOpen(false);
          props.callback();
          return response.data.message;
        },
        error: (err) => {
          props.setOpen(false);
          props.callback();
          return err.response.data.message;
        },
      },
      {
        style: {
          background: '#1e1e1e',
          color: '#ffffff',
        },
        success: {
          duration: 2500,
        },
      }
    );
  };

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog
        as="div"
        className={`fixed inset-0 z-10 ${dark ? 'dark' : ''} overflow-y-auto`}
        initialFocus={cancelButtonRef}
        onClose={props.setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 dark:bg-darkMode-200 dark:bg-opacity-75 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white dark:bg-darkMode-200 dark:border-darkMode-100 border-4 dark:text-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full dark:bg-opacity-30 dark:bg-red-700 bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <PlusCircleIcon
                      className="h-6 w-6 text-red-600"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-3 w-full text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium"
                    >
                      Add Public Script
                    </Dialog.Title>
                    <div className="mt-2"></div>
                    <div className="mt-2">
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Script Name
                        </label>
                        <div className="mt-1">
                          <input
                            type="email"
                            onChange={(e) => setName(e.target.value)}
                            id="email"
                            className="shadow-sm focus:ring-blue-600 transition dark:bg-darkMode-200 dark:border-darkMode-100 focus:border-blue-600 block w-full sm:text-sm border-gray-300 rounded-md"
                            placeholder="My Script"
                          />
                        </div>
                      </div>
                      <div className="mt-2">
                        <div>
                          <label
                            htmlFor="email"
                            className="block text-sm font-medium text-gray-700 dark:text-white"
                          >
                            Thumbnail URL
                          </label>
                          <div className="mt-1">
                            <input
                              type="email"
                              onChange={(e) => setThumbnail(e.target.value)}
                              id="email"
                              className="shadow-sm focus:ring-blue-600 transition dark:bg-darkMode-200 dark:border-darkMode-100 focus:border-blue-600 block w-full sm:text-sm border-gray-300 rounded-md"
                              placeholder="https://cdn.discordapp.com/attachments/799386923864424448/987431002479665202/unknown.png"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2">
                      <label
                        htmlFor="comment"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Description
                      </label>
                      <div className="mt-1">
                        <textarea
                          rows={2}
                          name="comment"
                          id="comment"
                          onChange={(e) => setDescription(e.target.value)}
                          className="shadow-sm focus:ring-blue-600 transition dark:bg-darkMode-200 dark:border-darkMode-100 focus:border-blue-600 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder="This is a description of the script"
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      <label
                        htmlFor="comment"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Script
                      </label>
                      <div className="mt-1">
                        <textarea
                          rows={4}
                          name="comment"
                          id="comment"
                          onChange={(e) => setScript(e.target.value)}
                          className="shadow-sm focus:ring-blue-600 transition dark:bg-darkMode-200 dark:border-darkMode-100 focus:border-blue-600 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder='You MUST replace the username with USERNAME, ex: require(1).load("USERNAME")'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={submitScript}
                  >
                    Create
                  </button>
                  <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center dark:bg-darkMode-200 dark:border-darkMode-100 dark:text-white ring-offset-transparent transition rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={() => props.setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default PublicScriptModal;
